import tenantUtils from '@utils';
import { NetworkService } from '../../../../services/networkService';
import moment from 'moment';

export const tasksMapper = (task) => ({
  id: task?.id,
  dateAdded: { value: task?.created_at, showTime: true, showPopover: false },
  completedTask: {
    childTask: {
      date: task?.completed_at,
      showTime: true,
      showPopover: false,
      title: task?.task_purpose?.name,
      title_l1: task?.task_purpose?.name_l1,
    },
  },
  plannedTask: {
    childTask: {
      date: task?.child?.due_date,
      showTime: true,
      showPopover: false,
      title: task?.child?.task_purpose?.name,
      title_l1: task?.child?.task_purpose?.name_l1,
      isOverdue: task?.child?.due_date ? moment(task.child.due_date).isBefore(moment()) : false,
    },
  },
  taskType: task?.task_type,
  notes: {
    value: task?.notes,
    imageUrl: task?.images?.[0]?.full || null,
    imageName: task?.images?.[0]?.filename,
  },
});

export const getTasks = async (leadId, queryObj) => {
  const response = await NetworkService.get(`/api/lms/tasks?q[taskable_id_eq]=${leadId}&page=${queryObj?.page || 1}`);
  if (response?.error) {
    return { error: response.error };
  }

  return {
    table: [
      {
        title: 'Date Added',
        dataIndex: 'dateAdded',
        key: 'dateAdded',
        component: 'Date',
      },
      {
        title: 'Completed Task',
        dataIndex: 'completedTask',
        key: 'completedTask',
        component: 'TaskDetail',
      },
      {
        title: 'Planned Task',
        dataIndex: 'plannedTask',
        key: 'plannedTask',
        component: 'TaskDetail',
      },
      {
        title: 'Notes',
        dataIndex: 'notes',
        key: 'notes',
        component: 'TaskNotes',
      },
    ],
    list: response?.data?.lead_tasks.map(tasksMapper),
    pagination: tenantUtils.getPaginationObject(response?.data?.pagination),
  };
};
